import { PropertyDetailsScreenWeb } from '@/modules/property-details/PropertyDetailsScreenWeb';
import React from 'react';

/** Web owned-property details — unchanged from before the mobile-only work. */
export default function PropertyDetailsRoute() {
  return <PropertyDetailsScreenWeb />;
}
